// @ts-check
import { get, getAll } from "./utility";

if ( !HTMLElement.prototype.checkVisibility ) {
    /**
     * Simple polyfill for older browsers that aren't supporting .checkVisibility()
     */
    HTMLElement.prototype.checkVisibility = function() {
        return !!( this.offsetWidth || this.offsetHeight || this.getClientRects().length );
    };
}


class Checkout {
    /**
     *
     * @param {HTMLElement} wrapper
     */
    constructor( wrapper ) {
        this.wrapper = wrapper;
        this.pages = getAll( 'data-page', wrapper );
        this.steps = get( '.nucheckout__steps', wrapper );
        this.nav = get( '[data-page-nav]', wrapper );
        this.setUpNavigationListeners();
        this.setUpNavListeners();
        this.setUpCouponer();
    }

    currentPage() {
        const cur = /** @type {HTMLElement} */ ( get( '[data-page-active="true"]', this.wrapper ) );
        return cur;
    }

    nextPage() {
        const curNum = parseInt( this.currentPage().dataset.page );
        const next = /** @type {HTMLElement|null} */ ( this.getPage( curNum + 1 ) );
        return next;
    }

    prevPage() {
        const curNum = parseInt( this.currentPage().dataset.page );
        const prev = /** @type {HTMLElement|null} */ ( this.getPage( curNum - 1 ) );
        return prev;
    }

    /**
     *
     * @param {string|number} num
     */
    getPage( num ) {
        const page = /** @type {HTMLElement|null} */ ( get( `[data-page="${num}"]` ) );
        return page;
    }

    /**
     *
     * @param {string|number|HTMLElement|null} page
     * @returns {boolean} Indicates whether page was found and succesfully deactivated
     */
    deactivate( page ) {
        if ( !( page instanceof HTMLElement ) ) {
            page = /** @type {HTMLElement|null} */ ( get( `[data-page="${page}"]` ) );
        }
        if ( !page ) return false;
        page.dataset.pageActive = 'false';
        jQuery( page ).fadeOut();
        return true;
    }

    /**
     *
     * @param {string|number|HTMLElement|null} page
     * @returns {boolean} Indicates whether page was found and succesfully deactivated
     */
    activate( page ) {
        if ( !( page instanceof HTMLElement ) ) {
            page = /** @type {HTMLElement|null} */ ( get( `[data-page="${page}"]` ) );
        }
        if ( !page ) return false;
        page.dataset.pageActive = 'true';
        jQuery( page ).fadeIn();
        this.setNavState();
        this.wrapper.scrollIntoView();
        return true;
    }

    validate = () => {
        jQuery( '.validate-required [name]' ).trigger( 'validate' );

        const invalidEls = getAll( '.woocommerce-invalid' );
        const invalidElsArray = [...invalidEls];
        const visibleInvalidEls = invalidElsArray.filter( ( invalidEl ) => {
            return invalidEl.checkVisibility();
        } );

        if ( visibleInvalidEls.length !== 0 ) {
            const firstError = visibleInvalidEls[0];
            firstError.scrollIntoView( { behavior: 'smooth', block: 'nearest' } );
            return false;
        } else {
            return true;
        }
    };

    next = () => {
        if ( !this.validate() ) {
            return;
        }
        const next = this.nextPage();
        if ( next ) {
            this.deactivate( this.currentPage() );
            this.activate( next );
        }
    };
    prev = () => {
        const prev = this.prevPage();
        if ( prev ) {
            this.deactivate( this.currentPage() );
            this.activate( prev );
        }
    };

    setUpNavigationListeners() {
        getAll( '[data-next-page]' ).forEach( trigger => {
            trigger.addEventListener( 'click', this.next );
        } );
        getAll( '[data-prev-page]' ).forEach( trigger => {
            trigger.addEventListener( 'click', this.prev );
        } );
    }

    setUpNavListeners() {
        const triggers = getAll( '[data-page-nav]', this.nav );
        triggers.forEach( trigger => {
            trigger.addEventListener( 'click', ( e ) => {
                const newPageNum = e.currentTarget?.dataset?.pageNav ?? null;
                if ( !newPageNum ) return;
                const next = this.getPage( newPageNum );
                if ( !next ) return;

                this.deactivate( this.currentPage() );
                this.activate( next );
            } );
        } );
        this.setNavState();
    }

    setNavState() {
        const curNum = this.currentPage().dataset.page;
        getAll( '[data-page-nav]', this.nav ).forEach( item => {
            if ( item.dataset.pageNav === curNum ) {
                item.classList.add( 'active' );
            } else {
                item.classList.remove( 'active' );
            }
        } );
    }

    setUpCouponer() {
        const wrapper = /** @type {HTMLElement} */ ( get( '#order_review_coupon' ) );
        const coupon = get( '[data-coupon-code]', wrapper );
        const nonce = get( '[data-coupon-nonce]', wrapper );
        if ( !( coupon instanceof HTMLInputElement ) || !( nonce instanceof HTMLInputElement ) ) return;
        const notice = /** @type {HTMLElement} */( get( '[data-coupon-notice]', wrapper ) );
        const couponSubmit = /** @type {HTMLElement} */( get( '[data-coupon-submit]', wrapper ) );

        /**
         * @param {Event} e
         */
        const submitCoupon = async ( e ) => {
            e.preventDefault();
            const body = new URLSearchParams();
            body.append( 'security', nonce.value );
            body.append( 'coupon_code', coupon.value );

            couponSubmit.classList.add( 'loading' );
            const res = await fetch( '/?wc-ajax=apply_coupon', {
                method: 'POST',
                body
            } );

            if ( res.ok ) {
                couponSubmit.classList.remove( 'loading' );
                notice.innerHTML = await res.text();
                coupon.value = '';
                // @ts-ignore
                jQuery( document.body ).trigger( 'update_checkout' );
            } else {
                notice.textContent = "Something went wrong...";
                couponSubmit.classList.remove( 'loading' );
                // @ts-ignore
                jQuery( document.body ).trigger( 'update_checkout' );
            }
        };

        couponSubmit.addEventListener( 'click', submitCoupon );
        coupon.addEventListener( 'keypress', ( e ) => {
            if ( e.key !== 'Enter' ) return;
            submitCoupon( e );
        } );
    }

}


const checkout = ( get( '.nucheckout' ) );
if ( checkout instanceof HTMLElement ) {
    new Checkout( checkout );
}